import React, {
  useEffect,
  useRef,
  useImperativeHandle,
  forwardRef,
  useState,
} from 'react';
import EZUIKit from 'ezuikit-js';
import { request } from 'umi';
import { isMobile } from '@/util';

let apiPrefix = 'https://open.mokan.cn';
/**
 * serialNumber：设备号
 * playType：视频类型，live：直播，rec：回放
 */
const VideoPlayer = forwardRef(
  (
    {
      serialNumber,
      type,
      timestamp,
      clientCode,
      sign,
      playType = 'live',
      directional,
      message,
      voice,
      dimensions
    },
    ref,
  ) => {
    const [player, setPlayer] = useState(null);
    const containerRef = useRef(null);

    useEffect(() => {}, []);
    if (type === 'test') {
      apiPrefix = 'https://test-open.mokan.cn';
    }

    const fetchPlayerToken = () => {
      return request(`${apiPrefix}/openapi/video/getOkStreamToken`, {
        method: 'get',
        headers: {
          timestamp,
          clientCode,
          sign,
        },
        params: {
          serialNumber,
        },
      }).then((res) => {
        return res.data;
      });
    };
    const themeData = {
      header: {
        color: '#fff ',
        activeColor: '#FFFFFF',
        backgroundColor: '#000000',
        btnList: [
          {
            iconId: 'deviceID',
            part: 'left',
            defaultActive: 0,
            memo: '顶部设备名称',
            isrender: 0,
          },
        ],
      },
      footer: {
        color: '#FFFFFF',
        activeColor: '#1890FF',
        backgroundColor: '#00000021',
        btnList: [
          {
            iconId: 'play',
            part: 'left',
            defaultActive: 1,
            memo: '播放',
            isrender: 1,
          },
          {
            iconId: 'capturePicture',
            part: 'left',
            defaultActive: 0,
            memo: '截屏按钮',
            isrender: 0,
          },
          {
            iconId: 'sound',
            part: 'left',
            defaultActive: 0,
            memo: '声音按钮',
            isrender: voice ? 0 : 1,
          },
          {
            iconId: 'talk',
            part: 'left',
            defaultActive: 0,
            memo: '对讲按钮',
            isrender: message ? 1 : 0,
          },
          {
            iconId: 'pantile',
            part: 'left',
            defaultActive: 1,
            memo: '云台控制按钮',
            isrender: directional ? 0 : 1,
          },
          {
            iconId: 'zoom',
            part: 'left',
            defaultActive: 0,
            memo: '电子放大',
            isrender: 0,
          },
          {
            iconId: 'hd',
            part: 'right',
            defaultActive: 0,
            memo: '清晰度切换按钮',
            isrender: 1,
          },
          {
            iconId: 'webExpend',
            part: 'right',
            defaultActive: 0,
            memo: '网页全屏按钮',
            isrender: 1,
          },
        ],
      },
    };
    useEffect(() => {
      let isMounted = true; // 避免组件卸载后仍尝试setState

      const initPlayer = async () => {
        try {
          if (!isMounted) return;

          const response = await fetchPlayerToken();
          const accessToken = response.accessToken;

          // 如果已有player实例，则先停止它
          if (player) {
            player.stop();
          }
          const playerConfig = {
            id: containerRef.current.id, // 视频容器ID
            accessToken: accessToken,
            url: `ezopen://open.ys7.com/${serialNumber}/1.hd.${playType}`,
            plugin: ['talk'], // 加载插件，talk-对讲
            download: false,
            width: dimensions.width,
            height: dimensions.height,
            ...(playType === 'live'
              ? { themeData }
              : { template: 'mobileRec' }), //如果播放类型传入的是rec，使用模板主题，不使用自定义themeData
          };

          const newPlayer = new EZUIKit.EZUIKitPlayer(playerConfig);
          setPlayer(newPlayer);
          window.player = newPlayer;
        } catch (error) {
          console.error('Error initializing player:', error);
        }
      };

      initPlayer();

      return () => {
        isMounted = false; // 组件卸载时设置为false
        if (player) {
          player.stop(); // 清理工作
        }
      };
    }, [serialNumber, playType]); // 监听serialNumber, type的变化

    // 暴露给父组件的方法
    useImperativeHandle(ref, () => ({
      play: () => {
        return player?.play();
      },
      stop: () => {
        return player?.stop();
      },
      openSound: () => {
        return player?.openSound();
      },
      closeSound: () => {
        return player?.closeSound();
      },
      startSave: () => {
        if (player) {
          const timestamp = `${new Date().getTime()}`;
          player.startSave(timestamp).then((data) => {
            console.log('开始录像', data);
          });
        }
      },
      stopSave: () => player?.stopSave(),
      capturePicture: () => {
        if (player) {
          const timestamp = `${new Date().getTime()}`;
          // 返回Promise，使得父组件可以链式调用.then()
          return player.capturePicture(timestamp);
        } else {
          // 如果player不存在，抛出错误或者返回一个拒绝的Promise
          return Promise.reject('Player实例不存在');
        }
      },
      fullScreen: () => {
        return player?.fullScreen();
      },
      getOSDTime: () => {
        return player?.getOSDTime();
      },
      ezopenStartTalk: () => {
        return player?.startTalk();
      },
      ezopenStopTalk: () => {
        return player?.stopTalk();
      },
      reSize: (width, height) => player?.reSize(width, height),
    }));

    return (
      <div
        id="video-container"
        ref={containerRef}
        // style={{ width: '100%', height: '100%' }}
      ></div>
    );
  },
);

export default VideoPlayer;
